import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ToastService } from './toast.service';
import { Note } from '../models/note.model';
import { CrudService } from '../shared/grid/crud.service';

@Injectable({
  providedIn: 'root'
})
export class NoteService extends CrudService<Note> {

  constructor(http: HttpClient, private toastService: ToastService) {
    super('Note', http);
  }

  getNotes(taskAssignmentId: string) {
    return this.http.get<Note[]>(this.getApiUrl('Note/GetNotes'), {
      params: new HttpParams().set('taskAssignmentId', taskAssignmentId)
    });
  }
}